'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { CALYPSO, CALYPSO_DARK, EERIE, OBSIDIAN } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { DEFAULT_FOLDER_ICON, DEFAULT_OPEN_FOLDER_ICON, THEME_FOLDER_ICON, OPEN_THEME_FOLDER_ICON, DEFAULT_SERVERLESS_FUNCTION_FOLDER_ICON, DEFAULT_SERVERLESS_FUNCTION_OPEN_FOLDER_ICON, DEFAULT_PROJECT_OPEN_FOLDER_ICON, DEFAULT_PROJECT_FOLDER_ICON } from 'DesignData/constants/Icons';
const MiniIcon = styled(UIIcon).withConfig({
  displayName: "FolderIcon__MiniIcon",
  componentId: "sc-73n5yb-0"
})(["position:absolute;bottom:-5px;right:-2px;font-size:0.6em;"]);

const getFolderIcon = ({
  open,
  isThemeFolder,
  isServerlessFunctionFolder,
  isProjectFolder
}) => {
  if (isThemeFolder) {
    return open ? OPEN_THEME_FOLDER_ICON : THEME_FOLDER_ICON;
  } else if (isServerlessFunctionFolder) {
    return open ? DEFAULT_SERVERLESS_FUNCTION_OPEN_FOLDER_ICON : DEFAULT_SERVERLESS_FUNCTION_FOLDER_ICON;
  } else if (isProjectFolder) {
    return open ? DEFAULT_PROJECT_OPEN_FOLDER_ICON : DEFAULT_PROJECT_FOLDER_ICON;
  } else if (open) {
    return DEFAULT_OPEN_FOLDER_ICON;
  }

  return DEFAULT_FOLDER_ICON;
};

const getColor = props => {
  const {
    isThemeFolder,
    isLocked,
    isAncestorLocked,
    isHubspotRootFolder,
    isMarketplaceRootFolder,
    isReadOnly
  } = props;

  if (isHubspotRootFolder || isMarketplaceRootFolder || isReadOnly) {
    return CALYPSO_DARK;
  }

  if (isLocked || isAncestorLocked) {
    return EERIE;
  }

  if (isThemeFolder) {
    return CALYPSO;
  }

  return CALYPSO;
};

const FolderIcon = props => {
  const {
    // Prevent react error from passing to DOM
    // eslint-disable-next-line no-unused-vars
    isLocked
  } = props,
        passThroughProps = _objectWithoutPropertiesLoose(props, ["isReadOnly", "isLocked", "isThemeFolder", "isAncestorLocked", "isHubspotRootFolder", "isMarketplaceRootFolder", "isServerlessFunctionFolder", "isProjectFolder"]);

  const color = getColor(props);
  const folderIcon = getFolderIcon(props);

  const iconComponent = /*#__PURE__*/_jsx(UIIcon, {
    color: color,
    name: folderIcon,
    screenReaderText: props.screenReaderText,
    size: props.size
  });

  if (isLocked || props.isProjectFolder) {
    return /*#__PURE__*/_jsxs("div", Object.assign({}, passThroughProps, {
      style: {
        position: 'relative'
      },
      children: [iconComponent, /*#__PURE__*/_jsx(MiniIcon, {
        color: OBSIDIAN,
        name: "locked"
      })]
    }));
  }

  return iconComponent;
};

export default FolderIcon;